module.exports = __webpack_public_path__ + "img/kefu-ico.01fe443e.png";